import { JournalPage } from "@client/features/journal/JournalPage";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const DziennikSearchSchema = z.object({ f: z.string().optional() });
export type DziennikSearch = z.infer<typeof DziennikSearchSchema>;

export const Route = createFileRoute("/dziennik")({
  validateSearch: (search): DziennikSearch => DziennikSearchSchema.parse(search),
  component: DziennikPage,
});

function DziennikPage() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <JournalPage
      activeFilter={search.f ?? "wszystko"}
      onFilterChange={(f) => navigate({ search: { f: f === "wszystko" ? undefined : f } })}
    />
  );
}
